import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import '../data-viz/components/TopServices'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "values",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "labels",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { values, labels, helpText } = config

    let vals, labs

    if(Object.keys(sigmaData).length) {
        vals = sigmaData[values].slice(0,3)
        labs = sigmaData[labels].slice(0,3)
    }
    console.log(vals)
    return (
        <>
            <zero-top-services
                data-fill="var(--color-1)"
                data-bg="var(--neutral-2)"
                data-heading="Top 3 Services"
                data-format="currency"
                data-values={vals}
                data-labels={labs}
                data-help={helpText}></zero-top-services>
        </>
    )
}
